import React,{useState} from "react";
import { Link } from "react-router-dom";
import { connect, useDispatch } from 'react-redux';
import {
    loadingToggleAction,
    signupAction,
} from '../../store/actions/AuthActions';
// image
//import logo from "../../images/logo-full.png";

function Register(props) {
    let errorsObj = { name:'', email: '',password:'', bookingdesk: '',aboutus:'',companygst:'',companyemail:'',webdomain:'',sellrate:'',pramoters:'',yearsofcompany:'',bankname:'',branchname:'',accountnumber:'',ifsccode:'',callingnumber:'',watsappnumber:''};
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [bookingdesk, setBookingDesk] = useState('');
    const [aboutus, setAboutUs] = useState('');
    const [companygst, setCompanyGst] = useState('');
    const [companyemail, setCompanyEmail] = useState('');
    const [webdomain, setWebDomain] = useState('');
    const [sellrate, setSellRate] = useState('');
    const [pramoters, setPramoters] = useState('');
    const [yearsofcompany, setYearsCompany] = useState('');
    const [bankname, setBankName] = useState('');
    const [branchname, setBranchName] = useState('');
    const [accountnumber, setAccountNumber] = useState('');
    const [ifsccode, setIfscCode] = useState('');
    const [callingnumber, setCallingNumber] = useState('');
    const [watsappnumber, setWatsappNumber] = useState('');
    const [errors, setErrors] = useState(errorsObj);
    const dispatch = useDispatch();

    function onSignUp(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (name === '') {
            errorObj.name = 'Name is Required';
            error = true;
        }
        if (email === '') {
            errorObj.email = 'Email is Required';
            error = true;
        }
        if (password === '') {
            errorObj.password = 'Password is Required';
            error = true;
        }

        if (bankname === '') {
          errorObj.bankname = 'Bank Name is Required';
          error = true;
        }
        if (branchname === '') {
          errorObj.branchname = 'Branch Name is Required';
          error = true;
        }
        if (accountnumber === '') {
          errorObj.accountnumber = 'Account Number is Required';
          error = true;
        }
        if (ifsccode === '') {
          errorObj.ifsccode = 'IFSC Code is Required';
          error = true;
        }
        setErrors(errorObj);
        if (error) return;
        dispatch(loadingToggleAction(true));
        dispatch(signupAction(name, email,password, bookingdesk,aboutus,companygst,companyemail,webdomain,sellrate,pramoters,yearsofcompany,bankname,branchname,accountnumber,ifsccode,callingnumber,watsappnumber, props.history));
    }
  return (
    <div className="authincation h-100 p-meddle">
      <div className="container h-100">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-12">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className="text-center mb-3">
                    {/* <Link to="/login">
                      <img src={logo} alt="" />
                    </Link> */}
                    </div>
                      <h4 className="text-center mb-4 ">Sign up your account</h4>
                      <p>Please send us your Company details to join with us.</p>
                      {props.errorMessage && (
                        <div className=''>
                          {props.errorMessage}
                        </div>
                      )}
                      {props.successMessage && (
                        <div className=''>
                          {props.successMessage}
                        </div>
                      )}
                    <form onSubmit={onSignUp}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="mb-1 ">
                              <strong>Name</strong>
                            </label>
                            <input
                              type="text"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              className="form-control"
                              placeholder="Enter Name"
                            />
                          </div>
                          {errors.name && <div>{errors.name}</div>}
                          <div className="form-group mb-3">
                            <label className="mb-1 ">
                              <strong>Email</strong>
                            </label>
                            <input
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              className="form-control"
                              placeholder="hello@example.com"
                            />
                          </div>
                          {errors.email && <div>{errors.email}</div>}
                          <div className="form-group mb-3">
                            <label className="mb-1 ">
                              <strong>Password</strong>
                            </label>
                            <input
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              className="form-control"
                              placeholder="password"
                            />
                          </div>
                          {errors.password && <div>{errors.password}</div>}
                          <div className="form-group mb-3">
                            <label className="mb-1 ">
                              <strong>Booking Desk Details</strong>
                            </label>
                            <input
                              value={bookingdesk}
                              onChange={(e) =>
                                setBookingDesk(e.target.value)
                              }
                              className="form-control"
                              placeholder="Enter Booking Desk"
                            />
                          </div>
                          {errors.bookingdesk && <div>{errors.bookingdesk}</div>}
                          <div className="form-group mb-3">
                            <label className="mb-1 ">
                              <strong>About US</strong>
                            </label>
                            <input
                              value={aboutus}
                              onChange={(e) =>
                                setAboutUs(e.target.value)
                              }
                              className="form-control"
                              placeholder="Enter About US"
                            />
                          </div>
                          {errors.aboutus && <div>{errors.aboutus}</div>}
                          <div className="form-group mb-3">
                            <label className="mb-1 ">
                              <strong>Company GST Details</strong>
                            </label>
                            <input
                              value={companygst}
                              onChange={(e) =>
                                setCompanyGst(e.target.value)
                              }
                              className="form-control"
                              placeholder="Enter Company GST No"
                            />
                          </div>
                          {errors.companygst && <div>{errors.companygst}</div>}
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                              <label className="mb-1 ">
                                <strong>Company Email ID</strong>
                              </label>
                              <input
                                value={companyemail}
                                onChange={(e) =>
                                  setCompanyEmail(e.target.value)
                                }
                                className="form-control"
                                placeholder="Enter Company Email ID"
                              />
                            </div>
                            {errors.companyemail && <div>{errors.companyemail}</div>}
                            <div className="form-group mb-3">
                              <label className="mb-1 ">
                                <strong>Website/Domain Name</strong>
                              </label>
                              <input
                                value={webdomain}
                                onChange={(e) =>
                                  setWebDomain(e.target.value)
                                }
                                className="form-control"
                                placeholder="Enter Website/Domain Name"
                              />
                            </div>
                            {errors.webdomain && <div>{errors.webdomain}</div>}
                            <div className="form-group mb-3">
                              <label className="mb-1 ">
                                <strong>Show Buy or Sell Rate OR Only Sell</strong>
                              </label>
                              <input
                                value={sellrate}
                                onChange={(e) =>
                                  setSellRate(e.target.value)
                                }
                                className="form-control"
                                placeholder="Enter Buy or Sell Rate"
                              />
                            </div>
                            {errors.sellrate && <div>{errors.sellrate}</div>}
                            <div className="form-group mb-3">
                              <label className="mb-1 ">
                                <strong>Name Of Promoters</strong>
                              </label>
                              <input
                                value={pramoters}
                                onChange={(e) =>
                                  setPramoters(e.target.value)
                                }
                                className="form-control"
                                placeholder="Enter Promoters"
                              />
                            </div>
                            {errors.pramoters && <div>{errors.pramoters}</div>}
                            <div className="form-group mb-3">
                              <label className="mb-1 ">
                                <strong>How many years old is your Company</strong>
                              </label>
                              <input
                                value={yearsofcompany}
                                onChange={(e) =>
                                  setYearsCompany(e.target.value)
                                }
                                className="form-control"
                                placeholder="Enter Years of Company"
                              />
                            </div>
                            {errors.yearsofcompany && <div>{errors.yearsofcompany}</div>}
                        </div>
                      </div>
                      <hr/>
                      <div className="row">
                      <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="mb-1 ">
                              <strong>Bank Name</strong>
                            </label>
                            <input
                              type="text"
                              value={bankname}
                              onChange={(e) =>
                                setBankName(e.target.value)
                              }
                              className="form-control"
                              placeholder="Enter Bank Name"
                            />
                          </div>
                          {errors.bankname && <div>{errors.bankname}</div>}
                          <div className="form-group mb-3">
                            <label className="mb-1 ">
                              <strong>Branch Name</strong>
                            </label>
                            <input
                              value={branchname}
                              onChange={(e) => setBranchName(e.target.value)}
                              className="form-control"
                              placeholder="Enter Branch Name"
                            />
                          </div>
                          {errors.branchname && <div>{errors.branchname}</div>}
                          <div className="form-group mb-3">
                            <label className="mb-1 ">
                              <strong>Account Number</strong>
                            </label>
                            <input
                              value={accountnumber}
                              onChange={(e) =>
                                setAccountNumber(e.target.value)
                              }
                              className="form-control"
                              placeholder="Enter Account Number"
                            />
                          </div>
                          {errors.accountnumber && <div>{errors.accountnumber}</div>}
                          <div className="form-group mb-3">
                            <label className="mb-1 ">
                            <strong>IFSC CODE</strong>
                            </label>
                            <input
                              value={ifsccode}
                              onChange={(e) =>
                                setIfscCode(e.target.value)
                              }
                              className="form-control"
                              placeholder="Enter IFSC Code"
                            />
                          </div>
                          {errors.ifsccode && <div>{errors.ifsccode}</div>}
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                              <label className="mb-1 ">
                                <strong>Quick Calling Number</strong>
                              </label>
                              <input
                                value={callingnumber}
                                onChange={(e) =>
                                  setCallingNumber(e.target.value)
                                }
                                className="form-control"
                                placeholder="Enter Quick Calling Number"
                              />
                            </div>
                            {errors.callingnumber && <div>{errors.callingnumber}</div>}
                            <div className="form-group mb-3">
                              <label className="mb-1 ">
                                <strong>Whats App Number</strong>
                              </label>
                              <input
                                value={watsappnumber}
                                onChange={(e) =>
                                  setWatsappNumber(e.target.value)
                                }
                                className="form-control"
                                placeholder="Enter Whats App Number"
                              />
                            </div>
                            {errors.watsappnumber && <div>{errors.watsappnumber}</div>}
                        </div>
                      </div>
                      <div className="text-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-primary btn-block"
                        >
                          Sign me up
                        </button>
                      </div>
                    </form>
                    <div className="new-account mt-3">
                      <p className="">
                        Already have an account?{" "}
                        <Link className="text-primary" to="/login">
                          Sign in
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
    return {
        errorMessage: state.auth.errorMessage,
        successMessage: state.auth.successMessage,
        showLoading: state.auth.showLoading,
    };
};

export default connect(mapStateToProps)(Register);

